<template>
  <BaseTableView :head="tableHead" list-view="lgAndUp">
    <slot/>
  </BaseTableView>
</template>

<script>
import BaseTableView from "components/base/tableview/BaseTableView";

export default {
  name: "FinanceSalarySliceTable",
  components: {BaseTableView},
  data: () => ({
    tableMin: false,
  }),
  computed: {
    tableHead() {
      const salaryTable = this.localStorage.translations.pages.finance['salary-table'] || {}
      return [
        {text: salaryTable.period},
        {text: salaryTable.weeks},
        {text: salaryTable.worker_group || 'Worker Group'},
        {text: salaryTable.status},
        {text: '', active: true}
      ]
    }
  },
  methods: {
    onMin(value) {
      this.tableMin = value
    },
  }
}
</script>
